module.exports = __webpack_public_path__ + "static/devops-automation-main-banner-b0b341f45136a7942051e749206ca37f.svg";